require('../../advertisement-core/src/index.js');
require('../../advertisement-dfp/src/index.js');
